export default "/bundles/assets/photo6_3f8074286e13c7d04eea517b2dc847e0.png";